var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBuyNow = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2474 9.97435C14.9641 10.491 14.4141 10.8327 13.7891 10.8327H7.58073L6.66406 12.4993H16.6641V14.166H6.66406C5.3974 14.166 4.5974 12.8077 5.20573 11.691L6.33073 9.65768L3.33073 3.33268H1.66406V1.66602H4.38906L5.1724 3.33268H17.5057C18.1391 3.33268 18.5391 4.01602 18.2307 4.56602L15.2474 9.97435ZM16.0892 4.99935H5.96419L7.93919 9.16602H13.7892L16.0892 4.99935ZM6.66387 14.9993C5.7472 14.9993 5.00553 15.7493 5.00553 16.666C5.00553 17.5827 5.7472 18.3327 6.66387 18.3327C7.58053 18.3327 8.33053 17.5827 8.33053 16.666C8.33053 15.7493 7.58053 14.9993 6.66387 14.9993ZM13.3389 16.666C13.3389 15.7493 14.0805 14.9993 14.9972 14.9993C15.9139 14.9993 16.6639 15.7493 16.6639 16.666C16.6639 17.5827 15.9139 18.3327 14.9972 18.3327C14.0805 18.3327 13.3389 17.5827 13.3389 16.666Z",
    fill: "#F3F4F6"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBuyNow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/buy-now.324e1eb67350a7d43a3b5aa9299b2577.svg";